import MuiDrawer from '@mui/material/Drawer';

import ExitToAppIcon from '@mui/icons-material/ExitToApp';
import { styled, Theme, CSSObject } from '@mui/material/styles';

export interface ISCUIHeader {
    history: any;
}
export interface JwtPayload {
    name: string;
}

export const myMenuList = [
    {
        url: '#',
        text: 'Çıkış yap',
        icon: ExitToAppIcon,
    },
];

export const headerRootSx = {
    display: 'inline-block',
    padding: '1rem',
    paddingBottom: '2rem',
    marginTop: '2rem',
    width: '-webkit-fill-available',
    marginBottom: '1rem',
    marginRight: '5rem',
} as const;

export const headerPaperSx = {
    padding: '1rem',
    paddingBottom: '1rem',
    marginTop: '1rem',
    width: '-webkit-fill-available',
    marginBottom: '1rem',
    marginRight: '5rem',
} as const;

export const drawerHeaderIconSx = {
    marginLeft: '1.5rem',
    fontSize: '3rem',
    color: '#0c59cb',
    fontWeight: 'bold',
} as const;

export const drawerHeaderTextSx = {
    paddingLeft: '3rem',
    fontSize: '2rem',
    marginTop: '2rem',
    color: '#0c59cb',
    fontWeight: 'bold',
} as const;

export const openCloseDrawerSx = {
    textAlign: 'center',
} as const;

const _closedMixin = (theme: Theme): CSSObject => ({
    transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    overflowX: 'hidden',
    width: '63px',
});
const drawerWidth = window.screen.width >= 600 ? window.screen.width : 260;
export const Drawer = styled(MuiDrawer, {
    shouldForwardProp: (prop: any) => prop !== 'open',
})(({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    ...(!open && {
        ..._closedMixin(theme),
        '& .MuiDrawer-paper': _closedMixin(theme),
    }),
}));
